var exports = {
  "P": "label__4pC8-d",
  "z": "anchorWrapper__Shhtjx",
};

module.exports = exports;
